import React from 'react'
import { RiderInfoContextType, useRiderInfo } from './RiderInfoContext'

export function withRiderInfo<P extends RiderInfoContextType>(WrappedComponent: React.ComponentType<P>) {
  return (props: Omit<P, keyof RiderInfoContextType>) => {
    const { riderInfo, setRiderInfo } = useRiderInfo()

    return <WrappedComponent {...props as P} riderInfo={riderInfo} setRiderInfo={setRiderInfo} />
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/rider-info/RiderInfoHOC.tsx